// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  display: {
    thresholds: {
      lg: 1270 /* Edgeの仕様によりmobileと誤判定される問題に対処 */
    }
  },

  theme: {
    themes: {
      light: {
        colors: {
          background: '#F5F5F5'        /* grey-lighten-4 */,
          background2: '#E0E0E0'       /* grey-lighten-2 */,
          primary: '#1E88E5'           /* blue-darken-1 */,
          sidebar_subheader: '#EEEEEE' /* grey-lighten-3 */
        }
      }
    }
  }
})
